import styled from 'styled-components';
import { style } from '../../../style';

export const TrailsSection = styled.div`
  margin: 24px 0;
`;

export const TrailsList = styled.div`
  /* display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px; */
`;
